<template>
     <div id="app">
          <nav class="container" v-if="$route.name !== 'Social'">
               <router-link to="/">
                    <img src="@/assets/images/logo-large.svg" alt="" class="logo" />
               </router-link>
               <div class="links header-section">
                    <!-- <router-link v-if="$route.name != 'Partner'" to="/partner" class="link is-hidden-mobile">
                         <b-button type="is-primary"> Become a Partner</b-button>
                    </router-link> -->
                    <template v-if="$route.name == 'Partner' || $route.name == 'FAQ' || $route.name == 'How'">
                         <router-link to="/faq" class="link is-hidden-mobile">FAQs</router-link>
                         <router-link to="/howitworks" class="link is-hidden-mobile">How it works</router-link>
                    </template>
                    <template v-else>
                         <router-link to="/about" class="link is-hidden-mobile">About Us</router-link>
                    </template>
                    <router-link to="/career" class="link is-hidden-mobile">Careers</router-link>
                    <router-link to="/investor" class="link is-hidden-mobile">Investor</router-link>
                    <router-link to="/gallery" class="link is-hidden-mobile">Gallery</router-link>
                    <router-link to="/contact" class="link is-hidden-mobile">Contact Us</router-link>

                    <div class="link menuicon is-hidden-tablet" @click="menuopen = true">
                         <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 24H28M4 8H28H4ZM4 16H28H4Z" stroke="black" stroke-width="2"
                                   stroke-linecap="round" stroke-linejoin="round" />
                         </svg>
                    </div>
               </div>
          </nav>
          <router-view />
          <footer style="height: 550px; display: flex; align-items: end; " v-if="$route.name !== 'Social'">
               <div class="container">
                    <div class="columns">
                         <div class="column">
                              <div class="footer-logo">
                                   <img src="@/assets/images/logo-white.svg" alt="" />
                              </div>
                              <div class="socialcontainer">
                                   <a href="mailto:contactus@nestease.com" target="_blank" class="socials">
                                        <svg width="26" height="21" viewBox="0 0 26 21" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                             <path d="M4.225 9.06775e-09H21.775C22.8542 -7.06507e-05 23.8925 0.41282 24.6769 1.15397C25.4613 1.89513 25.9324 2.90835 25.9935 3.9858L26 4.225V16.575C26.0001 17.6542 25.5872 18.6925 24.846 19.4769C24.1049 20.2613 23.0916 20.7324 22.0142 20.7935L21.775 20.8H4.225C3.14582 20.8001 2.10752 20.3872 1.3231 19.646C0.538677 18.9049 0.0675983 17.8916 0.00650016 16.8142L9.06774e-09 16.575V4.225C-7.06507e-05 3.14582 0.41282 2.10752 1.15397 1.3231C1.89513 0.538677 2.90835 0.0675983 3.9858 0.00650016L4.225 9.06775e-09H21.775H4.225ZM24.05 6.9849L13.455 12.5619C13.3354 12.6251 13.2039 12.6627 13.0689 12.6723C12.934 12.682 12.7985 12.6634 12.6711 12.6178L12.5463 12.5632L1.95 6.9862V16.575C1.95002 17.1459 2.16472 17.696 2.55148 18.116C2.93825 18.536 3.46879 18.7952 4.0378 18.8422L4.225 18.85H21.775C22.3462 18.85 22.8964 18.6351 23.3164 18.248C23.7364 17.861 23.9955 17.3301 24.0422 16.7609L24.05 16.575V6.9849ZM21.775 1.95H4.225C3.65405 1.95002 3.10399 2.16472 2.68399 2.55148C2.264 2.93825 2.00478 3.46879 1.9578 4.0378L1.95 4.225V4.7827L13 10.5976L24.05 4.7814V4.225C24.05 3.65385 23.8351 3.10361 23.448 2.68358C23.061 2.26355 22.5301 2.00447 21.9609 1.9578L21.775 1.95Z"
                                                  fill="black" />
                                        </svg>
                                   </a>

                                   <a href="https://www.linkedin.com/company/nestease" target="_blank" class="socials">
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                             <path d="M19.3983 0H1.69541C0.759375 0 0 0.759375 0 1.69541V19.3983C0 20.3344 0.759375 21.0938 1.69541 21.0938H19.3983C20.3344 21.0938 21.0938 20.3344 21.0938 19.3983V1.69541C21.0938 0.759375 20.3344 0 19.3983 0V0ZM19.3983 19.4062C7.59111 19.4036 1.6875 19.401 1.6875 19.3983C1.69014 7.59111 1.69277 1.6875 1.69541 1.6875C13.5026 1.69014 19.4062 1.69277 19.4062 1.69541C19.4036 13.5026 19.401 19.4062 19.3983 19.4062ZM3.12715 7.90752H6.25693V17.9745H3.12715V7.90752ZM4.69336 6.53115C5.69268 6.53115 6.50742 5.71904 6.50742 4.71709C6.50742 4.47886 6.4605 4.24297 6.36933 4.02288C6.27817 3.80279 6.14455 3.60281 5.9761 3.43435C5.80764 3.2659 5.60766 3.13228 5.38757 3.04111C5.16748 2.94995 4.93159 2.90303 4.69336 2.90303C4.45513 2.90303 4.21924 2.94995 3.99915 3.04111C3.77906 3.13228 3.57907 3.2659 3.41062 3.43435C3.24217 3.60281 3.10855 3.80279 3.01738 4.02288C2.92622 4.24297 2.8793 4.47886 2.8793 4.71709C2.87666 5.71904 3.68877 6.53115 4.69336 6.53115ZM11.3458 12.9937C11.3458 11.6807 11.5963 10.4098 13.2231 10.4098C14.8263 10.4098 14.85 11.9101 14.85 13.0781V17.9745H17.9771V12.4532C17.9771 9.74268 17.3918 7.65703 14.2251 7.65703C12.7037 7.65703 11.6833 8.49287 11.2641 9.28389H11.2219V7.90752H8.21865V17.9745H11.3458V12.9937Z"
                                                  fill="black" />
                                        </svg>
                                   </a>

                                   <a href="https://www.instagram.com/nestease.us/" target="_blank" class="socials">
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                             <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M6.465 0.066C7.638 0.012 8.012 0 11 0C13.988 0 14.362 0.013 15.534 0.066C16.706 0.119 17.506 0.306 18.206 0.577C18.939 0.854 19.604 1.287 20.154 1.847C20.714 2.396 21.146 3.06 21.422 3.794C21.694 4.494 21.88 5.294 21.934 6.464C21.988 7.639 22 8.013 22 11C22 13.988 21.987 14.362 21.934 15.535C21.881 16.705 21.694 17.505 21.422 18.205C21.146 18.9391 20.7133 19.6042 20.154 20.154C19.604 20.714 18.939 21.146 18.206 21.422C17.506 21.694 16.706 21.88 15.536 21.934C14.362 21.988 13.988 22 11 22C8.012 22 7.638 21.987 6.465 21.934C5.295 21.881 4.495 21.694 3.795 21.422C3.06092 21.146 2.39582 20.7133 1.846 20.154C1.28638 19.6047 0.853315 18.9399 0.577 18.206C0.306 17.506 0.12 16.706 0.066 15.536C0.012 14.361 0 13.987 0 11C0 8.012 0.013 7.638 0.066 6.466C0.119 5.294 0.306 4.494 0.577 3.794C0.853723 3.06008 1.28712 2.39531 1.847 1.846C2.39604 1.2865 3.06047 0.853443 3.794 0.577C4.494 0.306 5.294 0.12 6.464 0.066H6.465ZM15.445 2.046C14.285 1.993 13.937 1.982 11 1.982C8.063 1.982 7.715 1.993 6.555 2.046C5.482 2.095 4.9 2.274 4.512 2.425C3.999 2.625 3.632 2.862 3.247 3.247C2.88205 3.60205 2.60118 4.03428 2.425 4.512C2.274 4.9 2.095 5.482 2.046 6.555C1.993 7.715 1.982 8.063 1.982 11C1.982 13.937 1.993 14.285 2.046 15.445C2.095 16.518 2.274 17.1 2.425 17.488C2.601 17.965 2.882 18.398 3.247 18.753C3.602 19.118 4.035 19.399 4.512 19.575C4.9 19.726 5.482 19.905 6.555 19.954C7.715 20.007 8.062 20.018 11 20.018C13.938 20.018 14.285 20.007 15.445 19.954C16.518 19.905 17.1 19.726 17.488 19.575C18.001 19.375 18.368 19.138 18.753 18.753C19.118 18.398 19.399 17.965 19.575 17.488C19.726 17.1 19.905 16.518 19.954 15.445C20.007 14.285 20.018 13.937 20.018 11C20.018 8.063 20.007 7.715 19.954 6.555C19.905 5.482 19.726 4.9 19.575 4.512C19.375 3.999 19.138 3.632 18.753 3.247C18.3979 2.88207 17.9657 2.60121 17.488 2.425C17.1 2.274 16.518 2.095 15.445 2.046V2.046ZM9.595 14.391C10.3797 14.7176 11.2534 14.7617 12.0669 14.5157C12.8805 14.2697 13.5834 13.7489 14.0556 13.0422C14.5278 12.3356 14.7401 11.4869 14.656 10.6411C14.572 9.79534 14.197 9.00497 13.595 8.405C13.2112 8.02148 12.7472 7.72781 12.2363 7.54515C11.7255 7.36248 11.1804 7.29536 10.6405 7.34862C10.1006 7.40187 9.57915 7.57418 9.1138 7.85313C8.64846 8.13208 8.25074 8.51074 7.9493 8.96185C7.64786 9.41296 7.45019 9.92529 7.37052 10.462C7.29084 10.9986 7.33115 11.5463 7.48854 12.0655C7.64593 12.5847 7.91648 13.0626 8.28072 13.4647C8.64496 13.8668 9.09382 14.1832 9.595 14.391ZM7.002 7.002C7.52702 6.47698 8.15032 6.0605 8.8363 5.77636C9.52228 5.49222 10.2575 5.34597 11 5.34597C11.7425 5.34597 12.4777 5.49222 13.1637 5.77636C13.8497 6.0605 14.473 6.47698 14.998 7.002C15.523 7.52702 15.9395 8.15032 16.2236 8.8363C16.5078 9.52228 16.654 10.2575 16.654 11C16.654 11.7425 16.5078 12.4777 16.2236 13.1637C15.9395 13.8497 15.523 14.473 14.998 14.998C13.9377 16.0583 12.4995 16.654 11 16.654C9.50046 16.654 8.06234 16.0583 7.002 14.998C5.94166 13.9377 5.34597 12.4995 5.34597 11C5.34597 9.50046 5.94166 8.06234 7.002 7.002V7.002ZM17.908 6.188C18.0381 6.06527 18.1423 5.91768 18.2143 5.75397C18.2863 5.59027 18.3248 5.41377 18.3274 5.23493C18.33 5.05609 18.2967 4.87855 18.2295 4.71281C18.1622 4.54707 18.0624 4.39651 17.936 4.27004C17.8095 4.14357 17.6589 4.04376 17.4932 3.97652C17.3275 3.90928 17.1499 3.87598 16.9711 3.87858C16.7922 3.88119 16.6157 3.91965 16.452 3.9917C16.2883 4.06374 16.1407 4.1679 16.018 4.298C15.7793 4.55103 15.6486 4.88712 15.6537 5.23493C15.6588 5.58274 15.7992 5.91488 16.0452 6.16084C16.2911 6.40681 16.6233 6.54723 16.9711 6.5523C17.3189 6.55737 17.655 6.42669 17.908 6.188V6.188Z"
                                                  fill="black" />
                                        </svg>
                                   </a>

                                   <a href="https://www.facebook.com/nestease.us/" target="_blank" class="socials">
                                        <svg width="22" height="22" viewBox="0 0 21 21" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                             <path d="M10.5 0C4.711 0 0 4.711 0 10.5C0 16.289 4.711 21 10.5 21C16.289 21 21 16.289 21 10.5C21 4.711 16.289 0 10.5 0ZM10.5 1.75C15.3431 1.75 19.25 5.65688 19.25 10.5C19.2521 12.5947 18.501 14.6204 17.1337 16.2073C15.7664 17.7942 13.874 18.8365 11.802 19.1441V13.0515H14.294L14.6851 10.5201H11.802V9.13762C11.802 8.08762 12.1476 7.154 13.1303 7.154H14.7096V4.9455C14.4323 4.90788 13.8451 4.8265 12.7356 4.8265C10.4186 4.8265 9.06063 6.04975 9.06063 8.8375V10.5201H6.67888V13.0515H9.06063V19.1222C7.01728 18.7859 5.16008 17.7341 3.82086 16.1546C2.48163 14.5751 1.74763 12.5708 1.75 10.5C1.75 5.65688 5.65688 1.75 10.5 1.75Z"
                                                  fill="black" />
                                        </svg> </a><a href="https://twitter.com/nestease_us" target="_blank"
                                        class="socials">
                                        <svg width="23" height="20" viewBox="0 0 23 20" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                             <path d="M22 1.0096C21.0859 1.65437 20.0738 2.14752 19.0027 2.47005C18.4278 1.80904 17.6638 1.34053 16.814 1.12789C15.9642 0.915252 15.0695 0.96874 14.2511 1.28112C13.4326 1.5935 12.7299 2.14971 12.2378 2.87451C11.7458 3.59931 11.4883 4.45774 11.5 5.33369V6.28823C9.82251 6.33173 8.16031 5.95969 6.66142 5.20525C5.16253 4.45081 3.87348 3.33739 2.90909 1.96414C2.90909 1.96414 -0.909091 10.5551 7.68182 14.3732C5.71596 15.7077 3.3741 16.3768 1 16.2823C9.59091 21.0551 20.0909 16.2823 20.0909 5.30505C20.09 5.03917 20.0645 4.77394 20.0145 4.51278C20.9888 3.55202 21.6762 2.33901 22 1.0096V1.0096Z"
                                                  stroke="black" stroke-width="1.90909" stroke-linecap="round"
                                                  stroke-linejoin="round" />
                                        </svg>
                                   </a>
                                   <a href="https://www.youtube.com/@nestease-us" target="_blank" class="socials">
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                             <path d="M11.2223 3.66699C11.7119 3.66969 12.9368 3.68153 14.2383 3.73366L14.6997 3.75378C16.0101 3.81582 17.3194 3.92181 17.9688 4.10287C18.8349 4.3462 19.5157 5.0562 19.7458 5.9562C20.1122 7.38537 20.158 10.1748 20.1637 10.8498L20.1645 10.9897V10.9995C20.1645 10.9995 20.1645 11.0029 20.1645 11.0094L20.1637 11.1493C20.158 11.8243 20.1122 14.6137 19.7458 16.0429C19.5125 16.9462 18.8317 17.6562 17.9688 17.8962C17.3194 18.0773 16.0101 18.1832 14.6997 18.2453L14.2383 18.2654C12.9368 18.3175 11.7119 18.3294 11.2223 18.3321L11.0074 18.3328H10.9979C10.9979 18.3328 10.9947 18.3328 10.9883 18.3328L10.7737 18.3321C9.73746 18.3264 5.40494 18.2796 4.027 17.8962C3.16083 17.6529 2.48004 16.9429 2.24991 16.0429C1.88355 14.6137 1.83775 11.8243 1.83203 11.1493V10.8498C1.83775 10.1748 1.88355 7.38537 2.24991 5.9562C2.48323 5.05286 3.16402 4.34287 4.027 4.10287C5.40494 3.71945 9.73746 3.67269 10.7737 3.66699H11.2223ZM9.16455 7.7912V14.2078L14.6645 10.9995L9.16455 7.7912Z"
                                                  fill="#B5B6B9" />
                                        </svg>
                                   </a>
                              </div>
                         </div>
                         <div class="footer-links column" style="width: 100%;">
                              <!-- <router-link to="/partner">Partner</router-link> -->
                              <router-link to="/about">About</router-link>
                              <router-link to="/contact">Contact Us</router-link>
                              <router-link to="/help">Help</router-link>
                              <router-link to="/terms">Terms</router-link>
                              <router-link to="/privacy">Privacy Policy</router-link>
                         </div>
                         <div class="download column">
                              <div v-if="$route.name == 'Partner'">
                                   <p>Get the Partner App</p>
                                   <a href="https://apps.apple.com/in/app/nestease-partner/id1539485053"
                                        target="_blank"><img src="@/assets/images/appstore.png" alt="" /></a>
                                   <a href="https://play.google.com/store/apps/details?id=com.nestease.partner"
                                        target="_blank"><img src="@/assets/images/playstore.png" alt="" /></a>
                              </div>
                              <div v-else>
                                   <p>Get the App</p>
                                   <div class="store-section">
                                        <a href="https://apps.apple.com/in/app/nestease/id1539350208"
                                             target="_blank"><img src="@/assets/images/appstore.png" alt="" /></a>
                                        <a href="https://play.google.com/store/apps/details?id=com.nestease.customer"
                                             target="_blank"><img src="@/assets/images/playstore.png" alt="" /></a>
                                   </div>
                              </div>
                         </div>
                    </div>
                    <div class="rights " style="text-align:center">
                         © 2025 nestease. All rights reserved
                    </div>
               </div>
          </footer>
          <b-sidebar v-model="menuopen" :fullheight="true" :fullwidth="false" :overlay="true" :right="true" v-if="$route.name !== 'Social'">
               <div class="sidebar">

                    <!-- <router-link v-if="$route.name != 'Partner'" to="/partner" class="link ">
                              <b-button type="is-primary"> Become a Partner</b-button>
                         </router-link> -->
                    <template v-if="$route.name == 'Partner' || $route.name == 'FAQ' || $route.name == 'How'">

                         <router-link to="/faq" class="link ">FAQs</router-link>
                         <router-link to="/howitworks" class="link ">How it works</router-link>
                    </template>

                    <template v-else>


                         <router-link to="/about" class="link ">About Us</router-link>
                    </template>


                    <router-link to="/career" class="link ">Careers</router-link>
                    <router-link to="/investor" class="link ">Investor</router-link>
                    <router-link to="/gallery" class="link">Gallery</router-link>
                    <router-link to="/contact" class="link ">Contact Us</router-link>

                    <!-- <template v-if="$route.name == 'Partner'">
                         <router-link to="/faq" class="link is-hidden-mobile">FAQs</router-link>

                         <router-link to="/about" class="link is-hidden-mobile">How it works</router-link>
                    </template>
                    <template v-else>
                         <router-link to="/partner" class="link is-hidden-mobile">
                              <b-button type="is-primary"> Become a partner</b-button>
                         </router-link>

                         <router-link to="/about" class="link is-hidden-mobile">About Us</router-link>
                    </template> -->
               </div>
          </b-sidebar>
     </div>
</template>
<script>

export default {
     data() {
          return {
               menuopen: false,
          };
     },

     methods: {},

     watch: {
          $route() {
               this.menuopen = false;
          },
     },
};
</script>
<style scoped lang="scss">
nav {
     display: flex;
     padding: 20px 0;

     .logo {
          width: 180px;
          height: 90%;
          display: flex;
          justify-content: center;
          margin-bottom: 10px;
     }

     .header-section {
          padding: 20px;
     }

     .links {
          margin-left: auto;
          margin-right: 0;

          display: flex;
          align-items: center;

          .link {
               margin-left: 30px;
               cursor: pointer;
               color: #5d6970;
          }

          .link:hover {
               color: #00c187;
          }

          .menuicon {
               position: relative;
               top: 5px;
          }
     }
}

.sidebar {
     .link {
          display: block;
          text-align: center;
          margin-top: 20px;
          color: #5d6970;
     }

     .link:hover {
          color: #00c187;
     }
}

.container {
     margin-inline: auto;
     padding: 0 16px;
}

footer {
     background: #0b0d17;
     color: white;
     padding: 30px 0;

     @media screen and (max-width: 700px) {
          text-align: center;
     }

     .columns {
          display: flex;
          flex-wrap: wrap;
          gap: 14px;

          .column {
               &:first-child {
                    flex: 0 0 auto;
                    min-width: 200px;
               }

               &.footer-links {
                    flex: 1;
                    min-width: 250px;
               }

               &.download {
                    flex: 0 0 auto;
                    min-width: 200px;
               }
          }
     }

     .footer-logo {
          display: flex;
          align-items: center;
     }

     .footer-links {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          gap: 10px;

          a {
               display: inline-block;
               margin-right: 20px;
               color: white;
          }

          a:hover {
               color: #00c187;
          }

          @media screen and (max-width: 700px) {
               justify-content: start;
          }
     }

     .links {
          margin-top: 20px;

          a {
               display: inline-block;
               margin-right: 20px;
               color: white;
          }

          a:hover {
               color: #00c187;
          }
     }

     .rights {
          font-size: 16px;
          opacity: 0.6;
          margin-top: 30px;
     }

     .download {
          text-align: start;

          @media screen and (max-width: 904px) {
               margin-top: 20px;
          }

          width: auto;

          p {
               font-size: 20px;
               margin-bottom: 10px;
          }

          a {
               display: block;

               img {
                    height: 40px;
                    margin-top: 5px;
               }
          }
     }

     .socialcontainer {
          margin-top: 20px;

          .socials {
               path {
                    fill: rgba(255, 255, 255, 0.7);
               }

               display: inline-block;
               margin-right: 20px;
          }

          .socials:hover {
               path {
                    fill: #00c187;
               }
          }
     }

     .store-section {
          display: flex;
          justify-content: start;
          align-items: center;
          flex-wrap: wrap;
          gap: 10px;
     }

     @media (min-width: 300px) {
          .store-section {
               justify-content: center;
          }
     }

     @media (min-width: 700px) {
          .store-section {
               justify-content: start;
          }
     }

     @media (min-width: 1200px) {
          .store-section {
               justify-content: start;
          }
     }
}
</style>
